<template>
<div>
    <div v-if="loadingConferenceData">

    </div>
    <div v-if="!loadingConferenceData">
        <div class="vue-nav-wrapper" style="background: url(/wp-content/themes/understrap-child/conferences-app-vue/walkuere_conferences_vue_app/src/assets/Frame21.svg);">
            <div class="container pt-3">
                <HeaderInfo></HeaderInfo>
                <nav class="px-0 mb-4 pt-1 vue-tracks-nav">
                    <h3 v-if="tracks" class="font-weight-bold h2 text-white mt-3 pb-3 program-day-f-s">All JAX Software Architecture Tracks</h3>
                    <div v-if="tracks" class="d-none d-md-flex flex-wrap row col-12 col-xl-8 p-0">
                        <div v-for="(aTrack, index) in tracks" :key="index" class="m-2">
                            <!-- v-bind:class="{ 'active': loadedArticle.isFree}" -->
                            <router-link active-class="active" v-if="aTrack && aTrack.name && aTrack._id" v-bind:class="{ 'forceActive': activeTrackids.includes(aTrack._id)}" class="big-link rounded d-block p-2 text-center h-100 each-track-f-s" :to="`/track/${aTrack.slug}`">{{aTrack.name}}</router-link>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mt-5 row p-0">
                        <div class="mx-2 mb-3">
                            <router-link class="big-link d-block px-2 py-2 rounded text-center" active-class="active" to="/">view the whole program</router-link>
                        </div>
                        <div class="mx-2">
                            <router-link class="big-link d-block px-2 py-2 rounded text-center" active-class="active" to="/speakers">view our speakers</router-link>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
        <div class="vue-min-height container pt-1">
            <router-view v-bind:settingsPerm="settingsPerm" v-slot="{ Component }">
                <!-- <keep-alive max="20">   -->
                <component :is="Component" />
                <!-- </keep-alive> -->
            </router-view>

        </div>
    </div>

    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'category'">
        <div v-if="showComponent[0]  && showComponent[0] === true"> 
            <categoryHighlights v-bind:settingsPerm="settingsPerm"></categoryHighlights>           
        </div>
        <div v-if="showComponent[0]  && showComponent[0] === true">
            <categoryEvents v-bind:settingsPerm="settingsPerm"></categoryEvents>            
        </div>
        <div v-if="showComponent[0] && showComponent[0] === true">
            <categoryCourses v-bind:settingsPerm="settingsPerm"></categoryCourses>            
        </div>
        <div v-if="showComponent[1] && showComponent[1] === true"> 
            <categoryTutorials v-bind:settingsPerm="settingsPerm"></categoryTutorials>           
        </div>
        <div v-if="showComponent[1] && showComponent[1] === true">
            <categoryArticles v-bind:settingsPerm="settingsPerm"></categoryArticles>            
        </div>
        <div v-if="showComponent[2] && showComponent[2] === true">
            <categoryMagazine v-bind:settingsPerm="settingsPerm"></categoryMagazine>            
        </div>
        <div v-if="showComponent[2] && showComponent[2] === true"> 
            <categoryAdvertisingEvent v-bind:settingsPerm="settingsPerm"></categoryAdvertisingEvent>           
        </div>
        <div v-if="showComponent[2] && showComponent[2] === true">
            <categoryExperts v-bind:settingsPerm="settingsPerm"></categoryExperts>            
        </div>
        <div v-if="showComponent[3] && showComponent[3] === true">
            <categoryConference v-bind:settingsPerm="settingsPerm"></categoryConference>
        </div>
        <div v-if="showComponent[3] && showComponent[3] === true">
            <categorySeries v-bind:settingsPerm="settingsPerm"></categorySeries>
        </div>
        <div v-if="showComponent[4] && showComponent[4] === true"> 
            <categoryAdvertisingProgram v-bind:settingsPerm="settingsPerm"></categoryAdvertisingProgram>           
        </div>
        <div v-if="showComponent[4] && showComponent[4] === true">
            <categoryColumn v-bind:settingsPerm="settingsPerm"></categoryColumn>            
        </div>
        <div v-if="showComponent[4] && showComponent[4] === true">
            <categoryInterviews v-bind:settingsPerm="settingsPerm"></categoryInterviews>            
        </div>
    </div>

    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'brandComplexes'">
        <brandMain v-bind:settingsPerm="settingsPerm"></brandMain>
    </div>

    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'partners'">
        <partnersListing v-bind:settingsPerm="settingsPerm"></partnersListing>
    </div>

    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'communities'">
        <communitiesListing v-bind:settingsPerm="settingsPerm"></communitiesListing>
    </div>

    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'partners_detail'">
        <partnerDetailsPage v-bind:settingsPerm="settingsPerm"></partnerDetailsPage>
    </div>

    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'brandSeeAllBtn'">
        <brandSeeAllBtn v-bind:settingsPerm="settingsPerm" :queryType="queryType" :label="label" :section="section"></brandSeeAllBtn>
    </div>
    
    <div v-if="settingsPerm && settingsPerm.displayType && settingsPerm.displayType == 'expertsListingDisplay'">
        <expertsListingDisplay v-bind:settingsPerm="settingsPerm"></expertsListingDisplay>
    </div>


</div>
</template>

<script>
import {
    ApolloClient,
    InMemoryCache,
} from '@apollo/client/core'
import {
    provideApolloClient,
    useQuery
} from "@vue/apollo-composable";
import CONCORD_QUERIES from "@/services/concord_queries.js"
import {
    watch
} from 'vue';
import HeaderInfo from './components/HeaderInfo.vue';
import categoryConference from './components/category/categoryConference.vue';
import categoryTutorials from './components/category/categoryTutorials.vue';
import categoryCourses from './components/category/categoryCourses.vue';
import categoryExperts from './components/category/categoryExperts.vue';
import categoryInterviews from './components/category/categoryInterviews.vue';
import categoryArticles from './components/category/categoryArticles.vue';
import categoryMagazine from './components/category/categoryMagazine.vue';
import categorySeries from './components/category/categorySeries.vue';
import categoryEvents from './components/category/categoryEvents.vue';
import categoryHighlights from './components/category/categoryHighlights.vue';
import categoryColumn from './components/category/categoryColumn.vue';
import categoryAdvertisingEvent from './components/category/categoryAdvertisingEvent.vue';
import categoryAdvertisingProgram from './components/category/categoryAdvertisingProgram.vue';
import brandMain from './components/brand/BrandMain.vue';
import partnersListing from './components/partners/components/partnersListing.vue';
import communitiesListing from './components/communities/communitiesListing.vue';
import partnerDetailsPage from './components/partners/components/partnerDetails.vue';
import brandSeeAllBtn from './components/brand/brandSeeAllBtn.vue'; 
import expertsListingDisplay from './components/expertsListingDisplay.vue';

import { ref } from 'vue';

function parseSettingsData(rawSettings) {
    if (!rawSettings) {
        return {};
    }

    const legacyJson = rawSettings.replace(/%30/g, '"');

    try {
        return JSON.parse(legacyJson);
    } catch (_legacyError) {
        //console.warn('Failed to parse legacy JSON. Attempting to decode as base64-encoded JSON.');
    }

    try {
        const decodedBinary = window.atob(rawSettings);
        const decodedBytes = Uint8Array.from(decodedBinary, (character) => character.charCodeAt(0));
        const decodedJson = new TextDecoder().decode(decodedBytes);
        return JSON.parse(decodedJson);
    } catch (_base64Error) {
        throw new Error('Invalid settings payload. Expected legacy escaped JSON or base64-encoded JSON.');
    }
}

export default {
    name: 'App',
    props: {
        settings: String
    },
    setup() {},
    components: {
        HeaderInfo,
        categoryConference,
        categoryTutorials,
        categoryCourses,
        categoryExperts,
        categoryInterviews,
        categoryArticles,
        categoryMagazine,
        categorySeries,
        categoryEvents,
        categoryHighlights,
        categoryColumn,
        categoryAdvertisingEvent,
        categoryAdvertisingProgram,
        brandMain,
        partnersListing,
        communitiesListing,
        partnerDetailsPage,
        brandSeeAllBtn,
        expertsListingDisplay
    },
    data() {
        return {
            settingsPerm: parseSettingsData(this.settings),
            result: false,
            tracks: [],
            loadingConferenceData: true,
            activeTrackids: [],
            showComponent: Array.from({ length: 13 }, () => ref(false)),
        }
    },
    created() {
        console.log('settingsPerm: ', this.settingsPerm);
        // Brand Complex ID and slug can be tested in below console.log
        this.activeTrackids = [];
        this.emitter.on('tracksRelatedSessions', (data) => {
            this.activeTrackids = [];
            if (data && data.length) {
                data.forEach(aTrack => {
                    if (aTrack && aTrack._id) {
                        this.activeTrackids.push(aTrack._id);
                    }
                });
            }
        })
        // const router = this.$router;
        // const queryString = window.location.search;
        // if (queryString.includes("?")) {
        //     let urlToReditect = queryString.substring(1);
        //     if (urlToReditect) {
        //         router.push({
        //             path: urlToReditect,
        //             replace: true
        //         });
        //     }
        // }
        if (this.settingsPerm.brandId) {
            const cache = new InMemoryCache();
            const apolloClient = new ApolloClient({
                cache,
                uri: this.settingsPerm.concordBackendURL,
            })
            provideApolloClient(apolloClient)
            let variablesForQuery = {
                id: this.settingsPerm.seriesId,
            };
            const {
                result
            } = useQuery(CONCORD_QUERIES.SESSIONS_TRACKS_QUERY, variablesForQuery, {
                fetchPolicy: 'cache-first',
            });
            watch(result, value => {
                let tracksIds = ['2tBFrtqguFgr6KPhR', '3LYfMmvbcfmNWyM98', '9acF6cyq4ajqAwdYR', 'LmgwyriAEubWQLHo7','gFiTfRZHd8i4Y88hB', 'rfhJcTScTPHKFqufH'];
                if (value && value.vueSessions && value.vueSessions.Sessions && value.vueSessions.Sessions.length) {
                    value.vueSessions.Sessions.forEach(aSession => {
                        if (aSession && aSession.tracks && aSession.tracks.length) {
                            aSession.tracks.forEach(aSessionTrack => {
                                if (aSessionTrack && aSessionTrack._id && !this.tracks.find(aTrack => {
                                        return aTrack._id == aSessionTrack._id
                                    })
                                ) {
                                    if (tracksIds.includes(aSessionTrack._id)) {
                                        this.tracks.push(aSessionTrack);
                                    }

                                }
                            });
                            if (this.tracks && this.tracks.length) {
                                this.tracks = this.tracks.sort((a, b) => {
                                    return a.name.localeCompare(b.name);
                                })
                            }
                        }
                    });
                    this.loadingConferenceData = false;
                } else {
                    this.loadingConferenceData = false;
                }
            })
        }

    },
      mounted() {
        this.loadComponentsWithDelay();
    },
    methods: {
        loadComponentsWithDelay() {
            let countDownSec = 150;
        for (let i = 0; i < this.showComponent.length; i++) {
            setTimeout(() => {
            this.showComponent[i] = true;
            }, i * countDownSec); // Delay in milliseconds (1 second delay for each component)
        }
        },
    },
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.vue-tracks-nav {
    padding: 30px;
}

.vue-tracks-nav{
    font-weight: bold;
    color: #2c3e50;
}

.vue-tracks-nav a.router-link-exact-active {
    color: #42b983;
}

.conference-shadow-rounded {
    border-radius: .25rem !important;
    box-shadow: 5px 5px 20px rgb(0 0 0 / 10%) !important;
}

.vue-min-height {
    min-height: 800px;
}

.vue-nav-wrapper {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position-x: center !important;
}

.big-link {
    background-color: #fff;
    color: #003D72;
    font-size: 15px;
}

.active.big-link,.forceActive.big-link {
    background-color: #49e9ff;
    color: #003D72;
}
.each-track-f-s{
    font-size:16px;
}
.box-border-radius {
    border-radius: .25rem !important;
}
.fixed-aspect-ratio-conf {
  aspect-ratio: 1 / 1; /* 1:1 aspect ratio */
}
.fixed-aspect-ratio {
  aspect-ratio: 2 / 1;
}
</style>
